import { getCurrentUser } from "aws-amplify/auth";
import { useSessionStore } from "@/stores/session";

async function authGuard(to, _from) {
    const sessionStore = useSessionStore();

    /** If the user tries to navigate to /, skip the guard check */
    if (to.path === "/") {
        return true;
    }

    try {
        /** Attempt to get the authenticated user */
        const { userId } = await getCurrentUser();

        if (userId) {
            /** User is authenticated, proceed to the route */
            sessionStore.setIsAuthenticated(true);
        } else {
            sessionStore.setIsAuthenticated(false);
            return "/unauthorised-access";
        }
    } catch (error) {
        sessionStore.setIsAuthenticated(false);
        return "/";
    }
}

export default authGuard;
